import './Sponsors.css';
import { useState, useRef, useEffect } from 'react';

const Sponsors = () => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      { rootMargin: "-100px" }
    );
    
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [isIntersecting]);

  useEffect(() => {
    if (isIntersecting) {
      ref.current.querySelectorAll("img").forEach((el) => {
        el.classList.add("slide-in");
      });
    } else {
      ref.current.querySelectorAll("img").forEach((el) => {
        el.classList.remove("slide-in");
      });
    }
  }, [isIntersecting]);

  return (
    <section className='section-integration container'>
      <h2 className='sponsors-title'>
        Actualmente, cobramos carteras de los siguientes<span className='lancaster-color'> servicios:</span>
      </h2>
      <div className='logo-wrap' ref={ref}>
        <img
          src='/img/sponsors/banco-azteca.svg'
          loading='lazy'
          alt='banco-azteca-logo'
          className='integration-logo'
          width="250"
        />
        <img
          src='/img/sponsors/italika.svg'
          loading='lazy'
          alt='italika-logo'
          className='integration-logo'
          width="132"
        />
        <img
          src='/img/sponsors/telcel.svg'
          loading='lazy'
          alt='telcel-logo'
          className='integration-logo'
          width="130"
        />
      </div>
    </section>
  );
};

export default Sponsors;
